module.exports = __webpack_public_path__ + "static/media/arrowdown-yellow.89053698.svg";